import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export interface Option {
  id: string | number;
  name: string;
  code?: string;
}

interface CustomAutoCompleteSingleSelectionProps {
  id?: string;
  label?: string;
  placeholder?: string;
  options: Option[];
  value?: Option | null;
  onChange: (value: Option | null) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  size?: 'small' | 'medium';
  noOptionsText?: string;
}

const CustomAutoCompleteSingleSelection: React.FC<
  CustomAutoCompleteSingleSelectionProps
> = ({
  id,
  label,
  placeholder,
  options,
  value,
  onChange,
  disabled,
  loading,
  className,
  size = 'small',
  noOptionsText = 'No options',
}) => {
  return (
    <Autocomplete
      id={id}
      className={className}
      options={options}
      value={value}
      getOptionLabel={(option) => option.name}
      onChange={(_, newValue) => onChange(newValue)}
      isOptionEqualToValue={(opt, val) => opt.id === val?.id}
      disabled={disabled}
      loading={loading}
      size={size}
      clearOnBlur={false}
      disableClearable={false}
      noOptionsText={noOptionsText}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          size={size}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: disabled ? '#d4d4d4' : '',
              '&.Mui-disabled': {
                backgroundColor: '#d4d4d4',
              },
            },
          }}
        />
      )}
      slotProps={{
        clearIndicator: {
          sx: {
            '& svg': {
              fontSize: 16, // <-- adjust size here
            },
          },
        },
      }}
    />
  );
};

export default CustomAutoCompleteSingleSelection;
